$(function() {
    // Tabs

    $('.tabs a').on('click', function(e) {
        if (!$(this).attr('data-tab')) {
            return;
        }

        e.preventDefault();

        var $this = $(this);
        var tab = $this.attr('data-tab');
        var parent = $this.closest('.tabs-wrapper');

        if ($this.hasClass('mobile-tab-link')) {
            $this.toggleClass('active').siblings().removeClass('active');
            $this.next().toggle();
        } else {
            $this.addClass('active').siblings().removeClass('active');
            parent.find('.tab-content[data-tab=' + tab + ']').addClass('active').siblings('.tab-content').removeClass('active');
        }
    });

    $('#plan-1').on('click', function(e) {
        $('.tabs').find('a[data-tab=plan-1]').addClass('active').siblings().removeClass('active');
        $('.tabs-wrapper').find('.tab-content[data-tab=plan-1]').addClass('active').siblings('.tab-content').removeClass('active');
    });

    $('#plan-2').on('click', function(e) {
        $('.tabs').find('a[data-tab=plan-2]').addClass('active').siblings().removeClass('active');
        $('.tabs-wrapper').find('.tab-content[data-tab=plan-2]').addClass('active').siblings('.tab-content').removeClass('active');
    });

    $('#plan-3').on('click', function(e) {
        $('.tabs').find('a[data-tab=plan-3]').addClass('active').siblings().removeClass('active');
        $('.tabs-wrapper').find('.tab-content[data-tab=plan-3]').addClass('active').siblings('.tab-content').removeClass('active');
    });

    $('#plan-4').on('click', function(e) {
        $('.tabs').find('a[data-tab=plan-4').addClass('active').siblings().removeClass('active');
        $('.tabs-wrapper').find('.tab-content[data-tab=plan-4]').addClass('active').siblings('.tab-content').removeClass('active');
    });

    if ($(window).width() < 851) {
        $('.overlapping-homepage-top-section .tabs a').on('click', function() {
            window.location.replace('' + $(this).attr('data-url') + '');
        });
    }
});